
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://yzuzlxzvfnoeuvtcfonx.supabase.co';
const supabaseAnonKey = 'sb_publishable_QE-PFTKQ0x4uoMKcpiU0CQ_UmDijDyN';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
